var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.841535 8.00827H9.13569L7.94109 6.89669C7.61527 6.59352 7.61527 6.10089 7.94109 5.79779C8.10396 5.64624 8.32118 5.57047 8.5384 5.57047C8.75562 5.57047 8.95919 5.64624 9.13571 5.79779L11.7556 8.23564C12.0814 8.53881 12.0814 9.03144 11.7556 9.33454L9.12214 11.7726C8.79632 12.0758 8.26691 12.0758 7.94116 11.7726C7.61534 11.4694 7.61534 10.9768 7.94116 10.6737L9.13576 9.56213H0.841608C0.380092 9.56213 0 9.20846 0 8.77901C0 8.34948 0.380092 8.00841 0.841608 8.00841L0.841535 8.00827Z",
    fill: "#43927C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1584 3.99158H2.8642L4.0588 5.10316C4.38462 5.40633 4.38462 5.89895 4.0588 6.20206C3.73299 6.50524 3.20357 6.50524 2.87783 6.20206L0.257907 3.76421C0.0950398 3.61266 0.0136108 3.42314 0.0136108 3.20841C0.0136108 3.00629 0.0950447 2.80416 0.257907 2.65261L2.87783 0.22739C3.04069 0.0758405 3.25792 7.05719e-05 3.47514 7.05719e-05C3.69236 7.05719e-05 3.89593 0.0758452 4.07245 0.22739C4.39827 0.530564 4.39827 1.02319 4.07245 1.32629L2.87785 2.43788H11.1584C11.6199 2.43788 12 2.79155 12 3.221C11.9865 3.63792 11.6199 3.9916 11.1584 3.9916L11.1584 3.99158Z",
    fill: "#43927C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevers);
export default __webpack_public_path__ + "static/media/revers.4c94c07e46ea8b5f1e9db79c7d308838.svg";
export { ForwardRef as ReactComponent };